/**
 * This allows us to exclude some MIDs from Optimizely if required for a specific application by CRO team.
 */
export const isUsingExcludedMid = (activeMid: string) => {
  const config = useRuntimeConfig();
  const EXCLUDED_MIDS = {
    shops: [
      'CAM-wxvanx|TCH-5g6nol|TCO-gm2vex|CTY-5g6nol|CCO-5g6nol|PRG-gkq9zg',
      'CAM-wxvanx|TCH-5g6nol|TCO-x2mwkg|CTY-5g6nol|CCO-5g6nol|PRG-gkq9zg',
    ] as string[],
  } as const;

  const excludedMidsForApplication = EXCLUDED_MIDS[config.public.APPLICATION as keyof typeof EXCLUDED_MIDS] || [];
  return excludedMidsForApplication.includes(activeMid);
};
